<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver"><i class="fa fa-chevron-left"></i></button>
        <button *ngIf="!visibilitySpinner" [disabled]="formInvalid" type="button" class="btn btn-outline-success" (click)="onSave()" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
        <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Guardando
        </button>
    </form>
</nav>

<div class="animated container-fluid">
    <!--<form class="needs-validation" [formGroup]="form" novalidate>-->

        <h4>{{ title }} Punto Inspección</h4>

        <div class="row">  
            <div class="col-md-12">

                <app-puntoinspeccion-edit [listPais]="listPais" [listProvincia]="listProvincia" [listTipoPuntoInspeccion]="listTipoPuntoInspeccion"
                                          [listMunicipio]="listMunicipio" [listZona]="listZona" [submitted]="submitted"
                                          [puntoInspeccion]="puntoInspeccion" [formGroup]="form" (back)="onBack()"
                                          (selectProvincia)="onSelectProvincia($event)" (selectPais)="onSelectPais($event)" (selectZona)="onSelectZona($event)" (selectMunicipio)="onSelectMunicipio($event)">

                </app-puntoinspeccion-edit>

                <app-puntoinspeccion-children *ngIf="isEspania"
                                          [puntoInspeccion]="puntoInspeccion" [formGroup]="form"
                                          (addAduana)="onAddAduana($event)" (deleteAduana)="onDeleteAduana($event)" (addIntervalo)="onAddIntervalo($event)" (deleteIntervalo)="onDeleteIntervalo($event)">                                              

                </app-puntoinspeccion-children>

            </div>
        </div>
    <!--</form>-->
</div>
